export type {
	CreditCardStartInformationContext,
	LoanStartInformationContext,
	StartInformationContext,
} from "./context";

export interface LoanStartInformationPayload {
	selectedOffer?: LoanStartInformationOfferType;
}

export enum LoanStartInformationOfferType {
	ORIGINAL = "original",
	COUNTEROFFER = "counter",
}
